import React from 'react';
import { cx } from './cx';

export interface AdminCardProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  /** tiêu đề thẻ 16px 600 */
  title?: React.ReactNode;
  /** nút/phần phụ bên phải tiêu đề */
  extra?: React.ReactNode;
  /** không đệm + overflow hidden: dùng cho bảng chạm mép thẻ */
  flush?: boolean;
  as?: 'section' | 'div' | 'article';
}

// Thẻ trắng bo 16px, bóng shadow-card, đệm 20px, không viền.
export const AdminCard = ({ title, extra, flush, as = 'section', className, children, ...rest }: AdminCardProps) => {
  const Tag = as as any;
  return (
    <Tag className={cx('adm-card', flush && 'adm-card--flush', className)} {...rest}>
      {(title || extra) && (
        <div className="adm-card__head">
          {title ? <h3 className="adm-card__title">{title}</h3> : <span />}
          {extra && <div className="adm-card__extra">{extra}</div>}
        </div>
      )}
      {children}
    </Tag>
  );
};

// Thanh công cụ đầu thẻ bảng (tab lọc + ô ngày + tìm kiếm), đệm 16px 20px, kẻ dưới.
export const AdminCardToolbar = ({ className, children, ...rest }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx('adm-card__toolbar', className)} {...rest}>
    {children}
  </div>
);

// Chân thẻ bảng: phân trang canh phải.
export const AdminCardFooter = ({ className, children, ...rest }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx('adm-card__footer', className)} {...rest}>
    {children}
  </div>
);

export default AdminCard;
